'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Popover", {
    enumerable: true,
    get: function() {
        return Popover;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _usePopover = require("./usePopover");
const _renderPopover = require("./renderPopover");
const Popover = (props)=>{
    const state = (0, _usePopover.usePopover_unstable)(props);
    return (0, _renderPopover.renderPopover_unstable)(state);
};
Popover.displayName = 'Popover';
